var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLp3Grid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 180,
    viewBox: "0 0 1440 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561 173L1427.39 130.691H1349.1H1270.8H1192.51H1114.23H1035.93H957.636L926.873 100.195L903.628 77.166L885.454 59.1555L870.866 44.6988L858.888 32.8261L848.875 22.9098L840.383 14.5016H803.722H767.061H730.4H693.723H657.061H620.4L610.801 22.9098L599.501 32.8261L585.953 44.6988L569.465 59.1555L548.945 77.166L522.676 100.195L487.915 130.691H409.619H331.324H253.046H174.751H96.4554H18.1767L-121 173",
    stroke: "url(#paint0_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.5566 172.999L96.4535 130.69L185.868 100.194H253.226H320.583H387.958H455.316L489.829 77.1652H548.943H608.057H667.171H726.284H785.398H844.512H903.626H962.74L994.23 100.194H1061.59H1128.96H1196.32H1263.68L1349.09 130.69L1467.55 172.999",
    stroke: "url(#paint1_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8926 172.999L174.752 130.69L253.229 100.194L312.492 77.1649L358.818 59.1543H411.472H464.142L490.99 44.6976H538.472H585.955H633.454H680.937H728.42H775.902H823.385H870.867H918.35H965.833L990.797 59.1543H1043.45H1096.12L1140.08 77.1649L1196.32 100.194L1270.8 130.69L1374.11 172.999",
    stroke: "url(#paint2_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1777 130.69L118.496 100.194H185.871L253.377 77.1652H312.491H371.605H430.718H489.832L516.812 59.1546L538.471 44.6979L556.265 32.8252H599.502H642.722H685.958H729.195H772.432H815.652H858.889H902.125L918.349 44.6979L938.126 59.1546L962.742 77.1652H1021.86H1080.97H1140.08H1199.2L1263.68 100.194H1331.06L1427.39 130.69",
    stroke: "url(#paint3_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.338 172.998L253.048 130.689L320.587 100.193L371.606 77.1644L411.472 59.1539L443.507 44.6972L469.809 32.8244H513.029L531.451 22.9082H571.135H610.803H650.488H690.172H729.84H769.525H809.193H848.877H888.562H928.23H967.914H1007.58L1031.82 32.8244H1075.04L1108.28 44.6972H1155.78L1201.45 59.1539",
    stroke: "url(#paint4_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561 172.999H1467.55H1374.11H1280.66H1187.22H1093.77H1000.34H906.899L879.358 130.69L859.499 100.194L844.514 77.1651L832.8 59.1546L823.383 44.6979L815.651 32.8252L809.191 22.9089L803.722 14.5007L799.014 7.27272L794.933 1H763.113H731.276H699.455H667.619L662.712 7.27272L657.061 14.5007L650.486 22.9089L642.721 32.8252L633.452 44.6979L622.135 59.1546L608.059 77.1651L590.05 100.194L566.193 130.69L533.117 172.999H439.672H346.227H252.781H159.336H65.8907H-27.5547H-121",
    stroke: "url(#paint5_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.779 173L331.322 130.691L387.958 100.195L430.715 77.1661L464.138 59.1555H516.809H569.462H622.133H674.803H727.457H780.128H832.798H885.452H938.122H990.793L1021.85 77.1661L1061.59 100.195L1114.22 130.691L1187.22 173",
    stroke: "url(#paint6_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.498 100.195L194.265 77.166H253.379L306.149 59.1554H358.819L396.025 44.6987H443.508H490.991L513.031 32.826H556.267L571.136 22.9098L583.742 14.5015H620.403L628.648 7.27356H662.715H696.799H730.866H764.95H799.017H833.101L840.387 14.5015H877.048L888.563 22.9098L902.127 32.826H945.347L965.834 44.6987H1013.32H1060.8L1096.12 59.1554H1148.79L1199.2 77.166H1258.31L1331.06 100.195",
    stroke: "url(#paint7_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.32 100.194H522.678H590.053H657.411H724.785H792.143H859.501H926.876H994.234",
    stroke: "url(#paint8_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.264 77.1655L253.477 59.155H306.147L348.541 44.6983H396.024L426.572 32.8255H469.809L491.765 22.9093H531.45L547.079 14.5011H583.74L594.562 7.27308L603.963 1.00037H635.783H667.62",
    stroke: "url(#paint9_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.475 59.155L301.056 44.6983H348.539L383.333 32.8255H426.57L452.096 22.9093H491.764L510.4 14.5011H547.078L560.493 7.27308H594.56H628.644L635.781 1.00037",
    stroke: "url(#paint10_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.561 172.999L644.486 130.69L657.406 100.195L667.17 77.1655L674.803 59.155L680.933 44.6983L685.955 32.8255L690.168 22.9093L693.72 14.5011L696.793 7.27308L699.453 1.00037",
    stroke: "url(#paint11_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.061 44.6983L340.117 32.8255H383.337L412.415 22.9093H452.1L473.743 14.5011H510.404L526.413 7.27308L540.308 1.00037H572.128H603.965",
    stroke: "url(#paint12_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.115 32.8255L372.745 22.9093H412.413L437.08 14.5011H473.741L492.327 7.27308H526.411H560.495L572.126 1.00037",
    stroke: "url(#paint13_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.082 1.00037H985.902H1017.74L1037.55 7.27308L1060.36 14.5011",
    stroke: "url(#paint14_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.93 1.00037H826.767L833.094 7.27308H867.162L877.041 14.5011H913.703L928.225 22.9093L945.341 32.8255H988.578L1013.31 44.6983L1043.45 59.155L1080.97 77.1655L1128.96 100.195L1192.5 130.69L1280.66 172.999",
    stroke: "url(#paint15_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.428 1.00037H922.248H954.085L969.4 7.27308L987.045 14.5011H1023.71L1047.27 22.9093H1086.95L1118.27 32.8255",
    stroke: "url(#paint16_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.77 1.00037H858.59H890.427L901.248 7.27308L913.706 14.5011H950.383L967.912 22.9093L988.581 32.8255H1031.82L1060.8 44.6983H1108.28L1148.79 59.155H1201.44L1258.31 77.1655",
    stroke: "url(#paint17_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.746 22.9093L400.42 14.5011H437.081L458.261 7.27308L476.65 1.00037H508.47H540.307",
    stroke: "url(#paint18_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.414 14.5011L424.172 7.27308H458.256H492.323L508.464 1.00037",
    stroke: "url(#paint19_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.172 7.27308L444.807 1.00037H476.644",
    stroke: "url(#paint20_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.904 1.00037L1003.47 7.27308H1037.55",
    stroke: "url(#paint21_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.248 1.00037L935.316 7.27308H969.4H1003.47L1023.71 14.5011H1060.37L1086.95 22.9093",
    stroke: "url(#paint22_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.594 1.00037L867.168 7.27308H901.252H935.319L950.387 14.5011H987.048L1007.58 22.9093H1047.27L1075.04 32.8255H1118.28L1155.78 44.6983",
    stroke: "url(#paint23_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.115 1.00037L764.949 7.27308L767.064 14.5011L769.526 22.9093L772.433 32.8255L775.903 44.6983L780.132 59.155L785.403 77.1655L792.143 100.195L801.065 130.69L813.456 172.999",
    stroke: "url(#paint24_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.276 1.00037L730.863 7.27308L730.4 14.5011L729.838 22.9093L729.194 32.8255L728.417 44.6983L727.459 59.155L726.286 77.1655L724.783 100.195L722.784 130.69L720.008 172.999",
    stroke: "url(#paint25_linear_188_1117)",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    width: 786,
    height: 49,
    fill: "url(#paint26_linear_188_1117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_1117",
    x1: 720,
    y1: 14.5016,
    x2: 720,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_188_1117",
    x1: 719.998,
    y1: 77.1652,
    x2: 719.998,
    y2: 172.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_188_1117",
    x1: 720.002,
    y1: 44.6976,
    x2: 720.002,
    y2: 172.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_188_1117",
    x1: 722.785,
    y1: 32.8252,
    x2: 722.785,
    y2: 130.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_188_1117",
    x1: 680.392,
    y1: 22.9082,
    x2: 680.392,
    y2: 172.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_188_1117",
    x1: 720,
    y1: 1,
    x2: 720,
    y2: 172.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_188_1117",
    x1: 719.998,
    y1: 59.1555,
    x2: 719.998,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_188_1117",
    x1: 724.778,
    y1: 7.27356,
    x2: 724.778,
    y2: 100.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_188_1117",
    x1: 720.001,
    y1: 100.194,
    x2: 720.001,
    y2: 180.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_188_1117",
    x1: 430.942,
    y1: 1.00037,
    x2: 430.942,
    y2: 77.1655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_188_1117",
    x1: 444.628,
    y1: 1.00037,
    x2: 444.628,
    y2: 59.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_188_1117",
    x1: 663.007,
    y1: 1.00037,
    x2: 663.007,
    y2: 172.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_188_1117",
    x1: 452.513,
    y1: 1.00037,
    x2: 452.513,
    y2: 44.6983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_188_1117",
    x1: 456.121,
    y1: 1.00037,
    x2: 456.121,
    y2: 32.8255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_188_1117",
    x1: 1007.22,
    y1: 1.00037,
    x2: 1007.22,
    y2: 14.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_188_1117",
    x1: 1037.8,
    y1: 1.00037,
    x2: 1037.8,
    y2: 172.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_188_1117",
    x1: 1004.35,
    y1: 1.00037,
    x2: 1004.35,
    y2: 32.8255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_188_1117",
    x1: 1042.54,
    y1: 1.00037,
    x2: 1042.54,
    y2: 77.1655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_188_1117",
    x1: 456.526,
    y1: 1.00037,
    x2: 456.526,
    y2: 22.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_188_1117",
    x1: 454.439,
    y1: 1.00037,
    x2: 454.439,
    y2: 14.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_188_1117",
    x1: 450.408,
    y1: 1.00037,
    x2: 450.408,
    y2: 7.27308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_188_1117",
    x1: 1011.73,
    y1: 1.00037,
    x2: 1011.73,
    y2: 7.27308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_188_1117",
    x1: 1004.6,
    y1: 1.00037,
    x2: 1004.6,
    y2: 22.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_188_1117",
    x1: 1007.19,
    y1: 1.00037,
    x2: 1007.19,
    y2: 44.6983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_188_1117",
    x1: 788.286,
    y1: 1.00037,
    x2: 788.286,
    y2: 172.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_188_1117",
    x1: 725.642,
    y1: 1.00037,
    x2: 725.642,
    y2: 172.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_188_1117",
    x1: 768,
    y1: 0,
    x2: 768,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLp3Grid);
export default __webpack_public_path__ + "static/media/LP3-grid.76078556ddc4d647ae87dbe3bb1c1649.svg";
export { ForwardRef as ReactComponent };